<template>
  <div
    v-if="variant !== 'settings'"
    :style="{width: width, height: height}"
    class="image"
    :class="[ variant ]"
  ></div>
  <div
    v-else-if="variant === 'settings'"
    :style="{width: width, height: height}"
    class="image"
    :class="[ variant ]"
  >
    <b-icon-gear
      class="gear-icon"
    />
  </div>
</template>

<script>
export default {
  name: 'BorderedAddButton',
  props: {
    width: {
      type: String,
      default: '45px',
    },
    height: {
      type: String,
      default: '45px',
    },
    variant: {
      type: String,
      default: 'add',
      validate: (val) => ['add', 'edit', 'settings'].includes(val),
    },
  },
};
</script>

<style lang="scss" scoped>
  .image {
    color: var(--btn-primary);
    border-radius: 50%;
  }
  .image.add {
    background: url("../../assets/img/circle-border-sm.svg"),
    url("../../assets/img/plus-button-blue.svg") no-repeat center;
  }
  .image.edit {
    background: url("../../assets/img/circle-border-sm.svg"),
    url("../../assets/img/edit-blue-sm.svg") no-repeat center;
  }
  .image.settings {
    background: url("../../assets/img/circle-border-sm.svg");
    display: flex;
    justify-content: center;
    align-items: center;
    .gear-icon {
      font-size: 18px;
    }
  }
</style>
